export const Footer = () => (
  <footer className="footer">
    <div className="container footer__inner">
      <span>{"// "}designed &amp; built by suman, mmxxvi · v4.2.1</span>
      <span>process exited with code 0</span>
    </div>
  </footer>
);
